import { useTranslation } from 'react-i18next';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import { useAuthStore } from '@/auth/store';
import { fullName } from '@/auth/types';
import { CountersDueWidget } from './dashboard/CountersDueWidget';

/**
 * DashboardPage — F2 stub.
 *
 * The lang switcher and logout that lived here in F1 have moved to the
 * Topbar (`AppShell`); this page is now focused on welcoming the user.
 * Real KPIs (open WOs, expiring certificates, drydock plans) follow in
 * later phases as those modules ship.
 */
export function DashboardPage() {
  const { t } = useTranslation();
  const user = useAuthStore((s) => s.user);

  if (!user) return null;

  return (
    <div className="mx-auto max-w-4xl space-y-6">
      <Card>
        <CardHeader>
          <CardTitle className="text-2xl">
            {t('dashboard.welcome', { name: fullName(user) })}
          </CardTitle>
          <CardDescription>{t('dashboard.subtitle')}</CardDescription>
        </CardHeader>
        <CardContent>
          <dl className="grid gap-3 text-sm sm:grid-cols-2">
            <div>
              <dt className="font-medium text-muted-foreground">Email</dt>
              <dd className="break-all">{user.email}</dd>
            </div>
            <div>
              <dt className="font-medium text-muted-foreground">Roles</dt>
              <dd className="flex flex-wrap gap-1">
                {user.roles.map((r) => (
                  <span
                    key={r}
                    className="inline-flex items-center rounded-md bg-secondary px-2 py-0.5 text-xs font-medium text-secondary-foreground"
                  >
                    {r}
                  </span>
                ))}
              </dd>
            </div>
          </dl>
        </CardContent>
      </Card>
      <CountersDueWidget />
    </div>
  );
}
